import { useProject } from "@/queries/project-queries";
import { useEnvironmentTypes } from "@/hooks/use-environment-types";
import type { RunnerCapability } from "gitpod-next-api/gitpod/v1/runner_pb";

export function useRunnerCapabilities(projectId: string) {
    const { data: project } = useProject(projectId);
    const { envTypes } = useEnvironmentTypes();

    const projectClassId = project?.environmentClass?.environmentClass.case === "environmentClassId" 
        ? project.environmentClass.environmentClass.value 
        : undefined;

    const selectedEnvType = envTypes.find(et => et.clazz.id === projectClassId);
    const capabilities = selectedEnvType?.runner.status?.capabilities || [];

    return {
        capabilities,
        hasCapability: (capability: RunnerCapability) => capabilities.includes(capability),
    };
} 
